import moment from 'moment'

export const DAYS_PER_WEEK = 7

export const ISO_WEEK_CENTER_DAY_OFFSET = 3 // ISO weeks run Mon–Sun; Thursday is the midpoint day (Mon + 3).
export const DAY_TIMESCALE_WEEK_WIDTH_MULTIPLIER = 3

export const DAY_WIDTH_SCALE = 0.7
export const DAY_WIDTH_SCALE_2XL = 0.9
export const TAILWIND_2XL_QUERY = '(min-width: 1536px)'

export const SNAP_DELAY_MS = 120
export const SNAP_DURATION_MS = 220

export const RENDER_BUFFER_WEEKS = 2
export const RENDER_BUFFER_DAYS = RENDER_BUFFER_WEEKS * DAYS_PER_WEEK

export const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3)

export const getDayWidthScaleForWindow = () => {
    if (typeof window !== 'undefined' && window.matchMedia(TAILWIND_2XL_QUERY).matches) {
        return DAY_WIDTH_SCALE_2XL
    }
    return DAY_WIDTH_SCALE
}

export const getVisibleWeekCountForChartWidth = (widthPx) => {
    if (widthPx >= 1200) return 25
    if (widthPx >= 800) return 21
    return 17
}

export const getVisibleDayCount = (widthPx, timescale, dayWidthScale) => {
    const visibleWeeks = getVisibleWeekCountForChartWidth(widthPx)
    const totalDays = visibleWeeks * DAYS_PER_WEEK

    const baseVisibleDays = timescale === 'day'
        ? totalDays / DAY_TIMESCALE_WEEK_WIDTH_MULTIPLIER
        : totalDays

    // More days in the viewport → smaller daySpacing (DateTo*X and bar widths all derive from it).
    return baseVisibleDays / dayWidthScale
}

export const getSnapTargetDay = (dayOffset, timescale) => {
    if (timescale === 'day') {
        return Math.round(dayOffset)
    }
    return Math.round(dayOffset / DAYS_PER_WEEK) * DAYS_PER_WEEK
}

export const getViewportCenterDayOffset = (dayOffset, timescale) => {
    if (timescale === 'day') {
        return dayOffset
    }
    return dayOffset + ISO_WEEK_CENTER_DAY_OFFSET
}

export const buildTrainingTimelineDateRange = (referenceDate, plusMinusMonthRange = 36) => {
    const reference = moment(referenceDate)

    return {
        start: reference.clone().subtract(plusMinusMonthRange, 'months').startOf('isoWeek'),
        end: reference.clone().add(plusMinusMonthRange, 'months').endOf('isoWeek').startOf('day'),
    }
}

export const getTimelineDayOffsetBounds = (presentMonday, rangeStart, rangeEnd, timescale) => {
    const rangeStartDay = moment(rangeStart).startOf('day')
    const rangeEndDay = moment(rangeEnd).startOf('day')

    const minCenterDay = rangeStartDay.clone().add(ISO_WEEK_CENTER_DAY_OFFSET, 'days').diff(presentMonday, 'days')
    const maxCenterDay = rangeEndDay.clone().startOf('isoWeek').add(ISO_WEEK_CENTER_DAY_OFFSET, 'days').diff(presentMonday, 'days')

    if (timescale === 'day') {
        return { minDayOffset: rangeStartDay.diff(presentMonday, 'days'), maxDayOffset: rangeEndDay.diff(presentMonday, 'days') }
    }

    return {
        minDayOffset: minCenterDay - ISO_WEEK_CENTER_DAY_OFFSET,
        maxDayOffset: maxCenterDay - ISO_WEEK_CENTER_DAY_OFFSET,
    }
}

export const clampTimelineDayOffset = (dayOffset, { minDayOffset, maxDayOffset }) =>
    Math.min(maxDayOffset, Math.max(minDayOffset, dayOffset))
